import {useLocation, useNavigate} from 'react-router-dom'

type UseRouteTabs = (
  path: string,
  onChatOpen?: () => void
) => [string, (key: string) => void]

const useRouteTabs: UseRouteTabs = (path, onChatOpen) => {
  const {pathname} = useLocation()
  const navigate = useNavigate()

  const handleTabsChange = (key: string) => {
    if (key === 'chat') return onChatOpen()
    navigate(key)
  }

  const activeTab = pathname.replace(`/${path}/`, '').split('/')[0]

  return [activeTab, handleTabsChange]
}

export default useRouteTabs
